import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthEventService {
  private readonly unauthorizedNavigationPending$ =
    new BehaviorSubject<boolean>(false);

  public readonly isUnauthorizedNavigationPending$ =
    this.unauthorizedNavigationPending$.asObservable();

  setUnauthorizedNavigationPending(isPending: boolean): void {
    this.unauthorizedNavigationPending$.next(isPending);
  }

  get isUnauthorizedNavigationPending(): boolean {
    return this.unauthorizedNavigationPending$.value;
  }
}
